export default "__VITE_ASSET__8a8befeb__"